import type { FC } from 'react';

import { SeoTextBlock, Stack } from '@packages/shared';
import { SeoElementLinkList } from '@packages/modules';

import type { SearchSeoApiResponse } from '../../api/rest/types';

/**
 * Displays the SEO text for MBA
 * */
export const ProductListSeo: FC<{ data?: SearchSeoApiResponse }> = ({ data }) => {
  if (!data || Object.keys(data).length === 0) return null;

  const {
    text_2: seoText,
    relationlinks,
    toplinks,
    similarlinks,
    filterlinks,
    alternatebrands,
  } = data;

  return (
    <Stack rowGap={3} sx={{ paddingTop: 2 }}>
      <Stack role="rowgroup" rowGap={3}>
        {alternatebrands && alternatebrands.links && (
          <SeoElementLinkList linkList={alternatebrands.links} headline={alternatebrands.title} />
        )}
        {filterlinks && filterlinks.links && (
          <SeoElementLinkList linkList={filterlinks.links} headline={filterlinks.title} />
        )}
        {similarlinks && similarlinks.links && (
          <SeoElementLinkList linkList={similarlinks.links} headline={similarlinks.title} />
        )}
        {relationlinks && relationlinks.links && (
          <SeoElementLinkList linkList={relationlinks.links} headline={relationlinks.title} />
        )}
        {toplinks && toplinks.links && (
          <SeoElementLinkList linkList={toplinks.links} headline={toplinks.title} />
        )}
      </Stack>
      {seoText && <SeoTextBlock seoText={seoText} />}
    </Stack>
  );
};
